import React from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { DialogTitle, IconButton } from '@mui/material'

interface Props {
    children: string
    handleClose: () => void
}

const SearchCardConfigurationModalTitle: React.VFC<Props> = ({ children, handleClose }: Props) => (
    <DialogTitle sx={{ pt: 2, pb: 1 }}>
        {children}
        <IconButton
            sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
            }}
            color="primary"
            onClick={handleClose}
        >
            <CloseIcon color="primary" />
        </IconButton>
    </DialogTitle>
)

export default SearchCardConfigurationModalTitle
export type { Props as SearchCardConfigurationModalTitle }
